"use client";

import React, { useCallback } from "react";
import { useLabels, useLocale } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { fetchCompetitionPosts } from "@/app/(app)/actions/fetchCompetitionPosts";
import { CompetitionPostsPageClient } from "@/views/competition-news/partials/CompetitionPostsPageClient";
import type { Post } from "@/payload-types";

interface CompetitionVideosPageClientProps {
    initialPosts: Post[];
    totalPages: number;
    initialPage: number;
    competitionId: string;
    videosPerPage: number;
}

export const CompetitionVideosPageClient: React.FC<CompetitionVideosPageClientProps> = ({
    initialPosts,
    totalPages,
    initialPage,
    competitionId,
    videosPerPage,
}) => {
    const labels = useLabels();
    const locale = useLocale();
    const nav = useNavigation();

    const fetchPage = useCallback(
        (page: number) =>
            fetchCompetitionPosts({
                competitionId,
                locale,
                type: "video",
                page,
                limit: videosPerPage,
            }),
        [competitionId, locale, videosPerPage]
    );

    return (
        <CompetitionPostsPageClient
            initialPosts={initialPosts}
            totalPages={totalPages}
            initialPage={initialPage}
            postsPerPage={videosPerPage}
            heading={(labels.competitions as any).videos || "Videos"}
            emptyMessage="No videos available for this competition yet."
            buildLink={nav.post}
            fetchPage={fetchPage}
        />
    );
};
